import React from 'react';
import { DatePicker, Tooltip } from 'antd';
import FormItem from './FormItem';

const BaseDatePicker = ({
  form,
  label,
  name,
  initialValue,
  rules,
  tooltipProps = {},
  datePickerProps = {},
  disabled,
}) => {
  const { getFieldDecorator } = form;

  return (
    <Tooltip {...tooltipProps}>
      <FormItem label={label}>
        {getFieldDecorator(name, { initialValue: initialValue || null, rules })(
          <DatePicker
            disabled={disabled}
            {...datePickerProps}
            format="DD.MM.YYYY"
            showToday={false}
            style={{ width: '100%' }}
          />
        )}
      </FormItem>
    </Tooltip>
  );
};

export default BaseDatePicker;
